// Old admin surface for the case study ledger. The ledger now lives on the
// public site; send anyone landing on the admin path to the public page.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/case-studies/")({
  beforeLoad: () => {
    throw redirect({ to: "/case-studies" });
  },
});
